import React from "react";
import styled from "@emotion/styled";
import {Exists} from "components/Exists";
import {ENVIRONMENT} from "modules/constants";

const PreloaderWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	z-index: 29;
	background: rgba(0, 0, 0, 0.3);

	&.fixed {
		position: fixed;
		top: 0;
		left: 0;
		cursor: not-allowed;
	}
`;

const PreloaderContent = styled.div`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}
		100% {
			transform: translate(24px, 0);
		}
	}

	div {
		position: absolute;
		top: 33px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: #fff;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);

		&:nth-of-type(1) {
			left: 8px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-of-type(2) {
			left: 8px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(3) {
			left: 32px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(4) {
			left: 56px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
`;

const PreloaderText = styled.p`
	display: none;
	color: ${({theme}) => theme.colors.text.white};

	&.uat {
		display: block;
	}
`;

interface IProps {
	fixed?: boolean;
	preloaderText?: string;
}

export const Preloader: React.FC<IProps> = ({fixed, preloaderText}) => {
	const className = fixed ? "fixed" : "";
	return (
		<PreloaderWrapper className={className}>
			<PreloaderContent>
				<div />
				<div />
				<div />
				<div />
			</PreloaderContent>
			<Exists when={Boolean(preloaderText)}>
				<PreloaderText className={ENVIRONMENT}>{preloaderText}</PreloaderText>
			</Exists>
		</PreloaderWrapper>
	);
};
